import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  title: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginTop: "40px",
  },
  instructions: {
    fontSize: "0.8rem",
    fontWeight: "400",
    marginTop: "10px",
  },
  chartContainer: {
    alignSelf: "center",
    padding: "20px 20px 0px 20px",
    width: "100%",
    maxWidth: "600px",
  },
});

const PieChart = ({ title, pieData, global }) => {
  const classes = useStyles();

  return (
    <>
      <p className={classes.title}>{title}</p>
      <p className={classes.instructions}>Click para Detalles!</p>
      <div className={classes.chartContainer}>
        <Pie
          plugins={[ChartDataLabels]}
          data={pieData}
          options={{
            responsive: true,
            animation: false,
            plugins: {
              legend: {
                display: false,
              },
              datalabels: {
                display: (context) => {
                  const value = context.dataset.data[context.dataIndex];
                  const percentage = (value / global) * 100;
                  return percentage >= "15" ? true : false;
                },
                color: "white",
                font: {
                  size: 18,
                },
                formatter: (_, context) => {
                  return pieData.labels[context.dataIndex];
                },
              },
            },
          }}
        />
      </div>
    </>
  );
};

export default PieChart;
